import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const UpdatePluginListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePluginListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pluginListingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePluginListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"overview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overview"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginListingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pluginListingId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UpdatePluginListing","document":UpdatePluginListingDocument}} as const;
export type UpdatePluginListingMutationVariables = Types.Exact<{
  description?: Types.InputMaybe<Types.Scalars['String']['input']>;
  idPlugin: Types.Scalars['ID']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  overview?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pluginListingId: Types.Scalars['ID']['input'];
}>;


export type UpdatePluginListingMutation = (
  { __typename: 'Mutation' }
  & { updatePluginListing?: Types.Maybe<(
    { __typename: 'Plugin_Listing' }
    & Pick<Types.Plugin_Listing, 'description' | 'locale' | 'name' | 'overview'>
  )> }
);

export type UpdatePluginListingMutationFn = Apollo.MutationFunction<
  UpdatePluginListingMutation,
  UpdatePluginListingMutationVariables
>;

/**
 * __useUpdatePluginListingMutation__
 *
 * To run a mutation, you first call `useUpdatePluginListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePluginListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePluginListingMutation, { data, loading, error }] = useUpdatePluginListingMutation({
 *   variables: {
 *      description: // value for 'description'
 *      idPlugin: // value for 'idPlugin'
 *      locale: // value for 'locale'
 *      name: // value for 'name'
 *      overview: // value for 'overview'
 *      pluginListingId: // value for 'pluginListingId'
 *   },
 * });
 */
export function useUpdatePluginListingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePluginListingMutation,
    UpdatePluginListingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePluginListingMutation,
    UpdatePluginListingMutationVariables
  >(UpdatePluginListingDocument, options);
}
export type UpdatePluginListingMutationHookResult = ReturnType<
  typeof useUpdatePluginListingMutation
>;
export type UpdatePluginListingMutationResult =
  Apollo.MutationResult<UpdatePluginListingMutation>;
export type UpdatePluginListingMutationOptions = Apollo.BaseMutationOptions<
  UpdatePluginListingMutation,
  UpdatePluginListingMutationVariables
>;
